import { ContractError, HttpError, createApiClient, errorFields, shouldRetry as sharedShouldRetry } from '../../../api';
import type { ErrorFactory } from '../../../api';

export interface ApiViolation {
  readonly code: string;
  readonly message?: string;
  readonly keys?: string[];
  readonly autoFixable?: boolean;
}

export class ApiError extends HttpError {
  readonly violations: ApiViolation[];
  readonly expectedVersion: number | null;
  readonly currentVersion: number | null;
  readonly retryAfterSeconds: number | null;

  constructor(opts: {
    status: number;
    message: string;
    code?: string | null;
    violations?: ApiViolation[];
    expectedVersion?: number | null;
    currentVersion?: number | null;
    retryAfterSeconds?: number | null;
  }) {
    super(opts);
    this.name = 'ApiError';
    this.violations = opts.violations ?? [];
    this.expectedVersion = opts.expectedVersion ?? null;
    this.currentVersion = opts.currentVersion ?? null;
    this.retryAfterSeconds = opts.retryAfterSeconds ?? null;
  }
}

export class ApiContractError extends ContractError {
  constructor(message: string, issues: unknown) {
    super(message, issues);
    this.name = 'ApiContractError';
  }
}

const toError: ErrorFactory = (status, data) => {
  const body = (data ?? {}) as Record<string, unknown>;
  return new ApiError({
    status,
    ...errorFields(data),
    violations: Array.isArray(body.violations) ? (body.violations as ApiViolation[]) : [],
    expectedVersion: typeof body.expectedVersion === 'number' ? body.expectedVersion : null,
    currentVersion: typeof body.currentVersion === 'number' ? body.currentVersion : null,
    retryAfterSeconds: typeof body.retryAfterSeconds === 'number' ? body.retryAfterSeconds : null,
  });
};

export const { request } = createApiClient({ toError });

export const shouldRetry = sharedShouldRetry;
